import { Page } from '@/core/architecture'

import { ConsoleLotteryManagementDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleLotteryManagementDetail Page
 * Implemented as a practical sample.
 */
export const ConsoleLotteryManagementDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleLotteryManagementDetailTemplate state={state} {...actions} />
}
